export default "__VITE_ASSET__lBJ06_yd__"